import { render, staticRenderFns } from "./BinnacleModal.vue?vue&type=template&id=bfa8f0e0"
import script from "./BinnacleModal.vue?vue&type=script&lang=js"
export * from "./BinnacleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkPlan/WeeklyExecution/BinnacleModal.vue
// module id = 2669
// module chunks = 31